import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './DownloadModal.css';
import Button from '../Button';
import json2xls from 'json-as-xlsx';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ModalHeader } from 'react-bootstrap';
import { errorLogger } from '@utils/applicationLogUtils';

try {
    if (pdfFonts && (pdfFonts as any).pdfMake?.vfs) {
        pdfMake.vfs = (pdfFonts as any).pdfMake.vfs;
    } else if (pdfFonts && (pdfFonts as any).vfs) {
        pdfMake.vfs = (pdfFonts as any).vfs;
    }
} catch (error) {
    errorLogger('Failed to initialize pdfMake fonts: ' + error, 'DownloadModal');
}

interface ModalProps {
  
  closeModal: (value:boolean) => void;
  
 showModal: boolean;
 dataToExportExcel?:any;
 dataToExportPDF?:any;
 fileNameToExport?:string;
}
const DownloadModal: React.FC<ModalProps> = ({
  closeModal,
  showModal,
  dataToExportExcel,
  dataToExportPDF,
  fileNameToExport,
}) => {
    const [show,setShow]=useState<boolean>(showModal);
    const closeYes=()=>{
        closeModal(true);
    }
    const closeNo=()=>{
        closeModal(false);
    }
    const handleExportToExcel=()=>{ 
        json2xls(dataToExportExcel, {
          fileName: fileNameToExport,
          extraLength: 3, // A bigger number means that columns will be wider
          writeOptions: {
            // headerStyle: {
            //   font: {
            //     bold: true,
            //     color: { rgb: "FFFFFF" },
            //   },
            //   fill: {
            //     fgColor: { rgb: "000000" },
            //   },
            //   alignment: {
            //     horizontal: "center",
            //     vertical: "center",
            //   },
          }, // Style options 
        });
        closeModal(true);
       }
      const handleExportToPDF=()=>{
        const docDefinition = dataToExportPDF;
        pdfMake.createPdf(docDefinition).download(`${fileNameToExport}.pdf`);
        closeModal(true);
        //generatePDF(tableRef1, {filename: 'page.pdf'});
      }
  return (
    <>
      <Modal
        show={show}
        onHide={closeNo}
       // backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_download_button"
      >
        <ModalHeader closeButton>
        <div className="modal_title_download">Choose a format to download</div>

            </ModalHeader>
        <Modal.Body className="page_modal_body">
        <div className="modal_page_body_download">
            <Button
              onClick={handleExportToExcel}
              disabled={false}
              id=""
              buttonName={'Export To Excel'}
              colorType={'previous'}
              icon={''}
              iconPosition={''}
            />
             <Button
              onClick={handleExportToPDF}
              disabled={false}
              id=""
              buttonName={'Export To PDF'}
              colorType={'previous'}
              icon={''}
              iconPosition={''}
            />
          </div>
            
        </Modal.Body>
        
      </Modal>
    </>
  );
};

export default DownloadModal;
